import { style } from "@vanilla-extract/css";
import { cellStyles, columnStyles } from "plos/src/components/Table/tables.css";
import { borderedCell, breakpoints } from "plos/src/styles";

const etCell = style([
  cellStyles,
  {
    padding: 0,
  },
]);

export const etPlayerCell = style([borderedCell, etCell]);

export const etPlayerContainer = style({
  display: "flex",
  alignItems: "center",
});

export const etPointsCell = style([
  cellStyles,
  {
    textAlign: "end",
  },
]);

export const etPlayerCol = style([
  columnStyles,
  {
    width: "50%",
    textAlign: "start",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "70%",
      },
    },
  },
]);

export const etPointsCol = style([
  columnStyles,
  {
    width: "15%",
    textAlign: "end",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "30%",
      },
    },
  },
]);

export const availabilityCol = style({
  width: "50%",
});

export const newsCell = style([
  cellStyles,
  {
    textWrap: "wrap",
  },
]);
